module.exports = __webpack_public_path__ + "img/fr2.f689ce44.svg";